import React from 'react';
import useSpotConfig from '@host-panel/request/config/use-config';
import TitleAndDescription from '../../common/title-and-description';
import Switch from '../../common/inputs/customs/switch';

// Config feature flags
const ANALYTICS_PUSHER_FF = 'tenant.analytics-pusher.enabled';
const ANALYTICS_PUSHER_SENDERS_LIST = 'tenant.analytics-pusher.sendersList';

type Props = {};

const GoogleAnalytics: React.FC<Props> = ({}) => {
  const [configValues, setConfig] = useSpotConfig(
    [ANALYTICS_PUSHER_FF, ANALYTICS_PUSHER_SENDERS_LIST],
    {
      [ANALYTICS_PUSHER_FF]: false,
      [ANALYTICS_PUSHER_SENDERS_LIST]: []
    }
  );

  let [isAnalyticsPusherEnabled, AnalyticsPusherSendersList] = configValues;

  const handleGoogleAnalyticsChange = async (value: boolean) => {
    AnalyticsPusherSendersList = (AnalyticsPusherSendersList as any[]).includes('Google Analytics')
      ? AnalyticsPusherSendersList
      : [...(AnalyticsPusherSendersList as any[]), 'Google Analytics'];
    setConfig([
      { key: ANALYTICS_PUSHER_FF, value },
      { key: ANALYTICS_PUSHER_SENDERS_LIST, value: AnalyticsPusherSendersList }
    ]);
  };

  return (
    <div className="field">
      <TitleAndDescription
        title="Google Analytics"
        description="Send Conversation event data to the default Google Analytics tracker on my pages"
      />
      <Switch
        gapTopSize="analytics-toggle"
        value={isAnalyticsPusherEnabled}
        onChange={handleGoogleAnalyticsChange}
      />
    </div>
  );
};

export default GoogleAnalytics;
